import { config } from './config';
import { fetchAuthSession } from '@aws-amplify/auth';

interface Instance {
  id: string;
  name?: string;
  state: string;
  type?: string;
  ip?: string;
}

async function getAuthHeaders(): Promise<HeadersInit> {
  try {
    const session = await fetchAuthSession();
    const token = session?.tokens?.idToken?.toString();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  } catch (error) {
    return {
      'Content-Type': 'application/json',
    };
  }
}

export async function fetchInstances(): Promise<Instance[]> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${config.apiEndpoint}/instances`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch instances: ${response.statusText}`);
  }

  const data = await response.json();
  return data.instances ?? data;
}

export async function startInstance(id: string): Promise<void> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${config.apiEndpoint}/instances/${id}/start`, {
    method: 'POST',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to start instance: ${response.statusText}`);
  }
}

export async function stopInstance(id: string): Promise<void> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${config.apiEndpoint}/instances/${id}/stop`, {
    method: 'POST',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to stop instance: ${response.statusText}`);
  }
}
